import * as Types from '../types'
import { requestActionProps, requestGenerate } from '../../common'
import api from '../../../services/api'
import { callbackProps } from '../../../constants'

const actionGetStoryQuestionGroups = (
  payload:any,
  callback?: (a: callbackProps) => void
): requestActionProps => ({
  type: requestGenerate(Types.STORY_QUESTION_GROUP),
  api: api.getStoryQuestionGroups,
  payload: { data: new URLSearchParams(payload) },
  callback,
});
const actionGetStoryQuestionGroup = (
  payload: {storyId:number,languageCode:string},
  callback?: (a: callbackProps) => void
): requestActionProps => ({
  type: requestGenerate(Types.REQUEST),
  api: api.getStoryQuestionGroup,
  payload: { data: payload },
  callback,
});

export {
  actionGetStoryQuestionGroups,
  actionGetStoryQuestionGroup
};